import { render, staticRenderFns } from "./ModalNotContentPlan.vue?vue&type=template&id=09f0a50c"
import script from "./ModalNotContentPlan.vue?vue&type=script&lang=ts"
export * from "./ModalNotContentPlan.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports